import { render, staticRenderFns } from "./seeAnnouncement.vue?vue&type=template&id=51945d1d&scoped=true"
import script from "./seeAnnouncement.vue?vue&type=script&lang=js"
export * from "./seeAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./seeAnnouncement.vue?vue&type=style&index=0&id=51945d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51945d1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
